/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getConsumableGroups } from 'app/entities/consumable-group/consumable-group.reducer';
import { getEntities as getDeviceManufacurers } from 'app/entities/device-manufacurer/device-manufacurer.reducer';
import { getEntities as getCatalogDefinitions } from 'app/entities/catalog-definitions/catalog-definitions.reducer';
import { ConsumableType } from 'app/shared/model/enumerations/consumable-type.model';
import { createEntity, getEntity, reset, updateEntity } from './consumable.reducer';

export const ConsumableUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const consumableGroups = useAppSelector(state => state.consumableGroup.entities);
  const deviceManufacurers = useAppSelector(state => state.deviceManufacurer.entities);
  const catalogDefinitions = useAppSelector(state => state.catalogDefinitions.entities);
  const consumableEntity = useAppSelector(state => state.consumable.entity);
  const loading = useAppSelector(state => state.consumable.loading);
  const updating = useAppSelector(state => state.consumable.updating);
  const updateSuccess = useAppSelector(state => state.consumable.updateSuccess);
  const consumableTypeValues = Object.keys(ConsumableType);

  const handleClose = () => {
    navigate(`/consumable${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getConsumableGroups({}));
    dispatch(getDeviceManufacurers({}));
    dispatch(getCatalogDefinitions({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.price !== undefined && typeof values.price !== 'number') {
      values.price = Number(values.price);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }

    const entity = {
      ...consumableEntity,
      ...values,
      group: consumableGroups.find(it => it.id.toString() === values.group?.toString()),
      manufacturer: deviceManufacurers.find(it => it.id.toString() === values.manufacturer?.toString()),
      catalog: catalogDefinitions.find(it => it.id.toString() === values.catalog?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          type: 'PHARMACEUTICAL',
          ...consumableEntity,
          group: consumableEntity?.group?.id,
          manufacturer: consumableEntity?.manufacturer?.id,
          catalog: consumableEntity?.catalog?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.consumable.home.createOrEditLabel" data-cy="ConsumableCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.consumable.home.createOrEditLabel">Create or edit a Consumable</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="consumable-id"
                  label={translate('tinyMedicRestApp.consumable.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.consumable.type')}
                id="consumable-type"
                name="type"
                data-cy="type"
                type="select"
              >
                {consumableTypeValues.map(consumableType => (
                  <option value={consumableType} key={consumableType}>
                    {translate(`tinyMedicRestApp.ConsumableType.${consumableType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.consumable.name')}
                id="consumable-name"
                name="name"
                data-cy="name"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  maxLength: { value: 1000, message: translate('entity.validation.maxlength', { max: 1000 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumable.addedBy')}
                id="consumable-addedBy"
                name="addedBy"
                data-cy="addedBy"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumable.timestampentry')}
                id="consumable-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumable.active')}
                id="consumable-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumable.lastupdated')}
                id="consumable-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumable.unit')}
                id="consumable-unit"
                name="unit"
                data-cy="unit"
                type="text"
                validate={{
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumable.quantity')}
                id="consumable-quantity"
                name="quantity"
                data-cy="quantity"
                type="text"
                validate={{
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumable.price')}
                id="consumable-price"
                name="price"
                data-cy="price"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumable.cursor')}
                id="consumable-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.consumable.microSec')}
                id="consumable-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="consumable-group"
                name="group"
                data-cy="group"
                label={translate('tinyMedicRestApp.consumable.group')}
                type="select"
              >
                <option value="" key="0" />
                {consumableGroups
                  ? consumableGroups.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="consumable-manufacturer"
                name="manufacturer"
                data-cy="manufacturer"
                label={translate('tinyMedicRestApp.consumable.manufacturer')}
                type="select"
              >
                <option value="" key="0" />
                {deviceManufacurers
                  ? deviceManufacurers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="consumable-catalog"
                name="catalog"
                data-cy="catalog"
                label={translate('tinyMedicRestApp.consumable.catalog')}
                type="select"
              >
                <option value="" key="0" />
                {catalogDefinitions
                  ? catalogDefinitions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/consumable" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ConsumableUpdate;
